function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "add-user");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "add-user",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M998.428571,140.642857 L883.357143,140.642857 L883.357143,25.5714286 C883.357143,11.4512054 871.905938,0 857.785714,0 L832.214286,0 C818.094062,0 806.642857,11.4512054 806.642857,25.5714286 L806.642857,140.642857 L691.571429,140.642857 C677.451205,140.642857 666,152.094063 666,166.214286 L666,191.785714 C666,205.905938 677.451205,217.357143 691.571429,217.357143 L806.642857,217.357143 L806.642857,332.428571 C806.642857,346.548795 818.094063,358 832.214286,358 L857.785714,358 C871.905938,358 883.357143,346.548795 883.357143,332.428571 L883.357143,217.357143 L998.428571,217.357143 C1012.54879,217.357143 1024,205.905938 1024,191.785714 L1024,166.214286 C1024,152.094062 1012.54879,140.642857 998.428571,140.642857 Z",
  id: "Path",
  fill: "#05CDB3",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M519.4,684 C471.865625,684 449.009375,710.153846 371,710.153846 C292.990625,710.153846 270.3,684 222.6,684 C99.70625,684 0,782.403846 0,903.692308 L0,945.538462 C0,988.855769 35.609375,1024 79.5,1024 L662.5,1024 C706.390625,1024 742,988.855769 742,945.538462 L742,903.692308 C742,782.403846 642.29375,684 519.4,684 Z M664,946 L80,946 L80,904.171429 C80,826.396429 144.372727,763 223.345455,763 C247.568182,763 286.888636,789.142857 372,789.142857 C457.775,789.142857 496.265909,763 520.654545,763 C599.627273,763 664,826.396429 664,904.171429 L664,946 Z M371,654 C501.84375,654 608,547.619792 608,416.5 C608,285.380208 501.84375,179 371,179 C240.15625,179 134,285.380208 134,416.5 C134,547.619792 240.15625,654 371,654 Z M372,257 C459.064583,257 530,328.159896 530,415.5 C530,502.840104 459.064583,574 372,574 C284.935417,574 214,502.840104 214,415.5 C214,328.159896 284.935417,257 372,257 Z",
  id: "Shape",
  fill: "#05CDB3",
  fillRule: "nonzero"
}));

var SvgAddUser = function SvgAddUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-user.68ed20ef.svg";
export { ForwardRef as ReactComponent };